import { IOrderFrequency, isSingletonFrequency } from '../../types/order';
import {
    renderBaseInterval,
    renderRecurrenceUnit,
    renderRecurrenceUnitAdverb,
} from '../../types/recurrence';

export function renderOrderFrequencyOnceTwiceStyle({
    frequency,
    withIntervals,
}: {
    frequency: IOrderFrequency;
    withIntervals: boolean;
}) {
    if (isSingletonFrequency(frequency)) {
        return 'Once';
    }
    const { numVisitsPerInterval, intervalCount, intervalUnit } = frequency;
    let label = '';
    switch (numVisitsPerInterval) {
        case 1:
            label = `Once ${renderRecurrenceUnitAdverb(intervalUnit)}`;
            break;
        case 2:
            label = `Twice ${renderRecurrenceUnitAdverb(intervalUnit)}`;
            break;
        default:
            label = `${numVisitsPerInterval}x ${renderRecurrenceUnitAdverb(intervalUnit)}`;
            break;
    }
    if (withIntervals) {
        label += ` for ${intervalCount} ${renderRecurrenceUnit(intervalUnit, intervalCount)}`;
    }
    return label;
}

export function renderOrderFrequency1xStyle({
    frequency,
    withIntervals,
}: {
    frequency: IOrderFrequency;
    withIntervals: boolean;
}) {
    const { numVisitsPerInterval, intervalCount, intervalUnit } = frequency;
    let label = `${numVisitsPerInterval}x ${renderRecurrenceUnitAdverb(intervalUnit)}`;

    if (withIntervals) {
        label += ` for ${intervalCount} ${renderBaseInterval(intervalUnit, intervalCount)}`;
    }

    return label.toLowerCase();
}

export function renderOrderMinMaxActiveOccurrences({
    numActiveOccurrences,
    maxActiveOccurrences,
    minActiveOccurrences,
}: {
    numActiveOccurrences: number;
    maxActiveOccurrences: number;
    minActiveOccurrences: number;
}) {
    if (minActiveOccurrences === maxActiveOccurrences) {
        return `${numActiveOccurrences} / ${minActiveOccurrences} visits`;
    }
    return `${numActiveOccurrences} / ${minActiveOccurrences} - ${maxActiveOccurrences} visits`;
}
